import { getTheme } from '../styles/appTheme';

export const types = {
  CHANGE_THEME: 'CHANGE_THEME',
};

const getThemeFromCookies = () => document.cookie.replace(/(?:(?:^|.*;\s*)style\s*=\s*([^;]*).*$)|^.*$/, "$1");

export const actions = {
  initTheme: primaryColor => dispatch => {
    const selectedTheme = getThemeFromCookies();
    const appTheme = getTheme(selectedTheme && selectedTheme !== 'style-contrast-none' ? selectedTheme : primaryColor);
    return dispatch({ type: types.CHANGE_THEME, theme: appTheme });
  },
  changeTheme: style => (dispatch, getState) => {
    document.cookie = `style=${style || ''};path=/`;

    const appTheme = style ? getTheme(style) : getTheme(getState().cms.color);
    return dispatch({ type: types.CHANGE_THEME, theme: appTheme });
  },
};



// WEBPACK FOOTER //
// ./src/actions/themeActions.js